/* Reopen the store's existing consent UI. This file never creates a second banner or records consent. */
(() => {
  'use strict';
  if (window.SolvirosolPreferences) return;
  window.SolvirosolPreferences = true;
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-solvirosol-cookie-preferences]');
    if (!link) return;
    event.preventDefault();
    const status = link.parentElement.querySelector('[data-cookie-status]');
    try {
      const banner = typeof privacyBanner !== 'undefined' ? privacyBanner : window.privacyBanner;
      if (!banner || typeof banner.showPreferences !== 'function') throw new Error('Cookie preferences are not available right now. Please try again, or use our privacy policy contact details for help.');
      await banner.showPreferences();
      if (status) status.textContent = '';
    } catch (error) {
      if (status) status.textContent = error.message || 'Cookie preferences could not be opened. Please try again.';
    }
  });
})();
